import { RouterView } from "vue-router";

const docsRoutes = {
  path: "/docs",
  name: "Documentation",
  component: () => import("@/views/Docs/DocsView.vue"),
  children: [
    {
      path: "",
      name: "Docs Home",
      component: () => import("@/views/Docs/HomeView.vue"),
    },
    {
      path: "/docs/guides/traces",
      name: "Traces Initial Setup",
      component: () =>
        import("@/views/Docs/Topics/Guides/Traces/TracesView.vue"),
      props: { position: "documentation" },
      children: [
        {
          path: "/docs/guides/traces/cplusplus",
          name: "C++ Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/CPlusPlus.vue"),
        },
        {
          path: "/docs/guides/traces/dotnet",
          name: ".NET Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/DotNet.vue"),
        },
        {
          path: "/docs/guides/traces/erlangelixir",
          name: "Elixir/Erlang Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/ErlangElixir.vue"),
        },
        {
          path: "/docs/guides/traces/erlang",
          name: "Erlang Traces Initial Setup",
          redirect: "/docs/guides/traces/erlangelixir",
        },
        {
          path: "/docs/guides/traces/elixir",
          name: "Elixir Traces Initial Setup",
          redirect: "/docs/guides/traces/erlangelixir",
        },
        {
          path: "/docs/guides/traces/go",
          name: "Go Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/GoView.vue"),
        },
        {
          path: "/docs/guides/traces/java",
          name: "Java Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/JavaView.vue"),
        },
        {
          path: "/docs/guides/traces/javascript",
          name: "Javascript Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/JavascriptView.vue"),
        },
        {
          path: "/docs/guides/traces/nodejs",
          name: "NodeJS Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/NodeJS.vue"),
        },
        {
          path: "/docs/guides/traces/php",
          name: "PHP Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/PhpView.vue"),
        },
        {
          path: "/docs/guides/traces/python",
          name: "Python Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/PythonView.vue"),
        },
        {
          path: "/docs/guides/traces/ruby",
          name: "Ruby Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/RubyView.vue"),
        },
        {
          path: "/docs/guides/traces/rust",
          name: "Rust Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/RustView.vue"),
        },
        {
          path: "/docs/guides/traces/swift",
          name: "Swift Traces Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Traces/SwiftView.vue"),
        },
      ],
    },
    {
      path: "/docs/guides/metrics",
      name: "Metrics Initial Setup",
      component: () =>
        import("@/views/Docs/Topics/Guides/Metrics/MetricsView.vue"),
      props: { position: "documentation" },
      children: [
        {
          path: "/docs/guides/metrics/cplusplus",
          name: "C++ Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/CPlusPlus.vue"),
        },
        {
          path: "/docs/guides/metrics/dotnet",
          name: ".NET Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/DotNet.vue"),
        },
        {
          path: "/docs/guides/metrics/erlangelixir",
          name: "Elixir/Erlang Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/ErlangElixir.vue"),
        },
        {
          path: "/docs/guides/metrics/go",
          name: "Go Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/GoView.vue"),
        },
        {
          path: "/docs/guides/metrics/java",
          name: "Java Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/JavaView.vue"),
        },
        {
          path: "/docs/guides/metrics/javascript",
          name: "Javascript Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/JavascriptView.vue"),
        },
        {
          path: "/docs/guides/metrics/nodejs",
          name: "NodeJS Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/NodeJS.vue"),
        },
        {
          path: "/docs/guides/metrics/php",
          name: "PHP Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/PhpView.vue"),
        },
        {
          path: "/docs/guides/metrics/python",
          name: "Python Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/PythonView.vue"),
        },
        {
          path: "/docs/guides/metrics/ruby",
          name: "Ruby Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/RubyView.vue"),
        },
        {
          path: "/docs/guides/metrics/rust",
          name: "Rust Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/RustView.vue"),
        },
        {
          path: "/docs/guides/metrics/swift",
          name: "Swift Metrics Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Metrics/SwiftView.vue"),
        },
      ],
    },
    {
      path: "/docs/guides/logs",
      name: "Logs Initial Setup",
      component: () => import("@/views/Docs/Topics/Guides/Logs/LogsView.vue"),
      props: { position: "documentation" },
      children: [
        {
          path: "/docs/guides/logs/cplusplus",
          name: "C++ Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/CPlusPlus.vue"),
        },
        {
          path: "/docs/guides/logs/dotnet",
          name: ".NET Logs Initial Setup",
          component: () => import("@/views/Docs/Topics/Guides/Logs/DotNet.vue"),
        },
        {
          path: "/docs/guides/logs/erlangelixir",
          name: "Elixir/Erlang Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/ErlangElixir.vue"),
        },
        {
          path: "/docs/guides/logs/go",
          name: "Go Logs Initial Setup",
          component: () => import("@/views/Docs/Topics/Guides/Logs/GoView.vue"),
        },
        {
          path: "/docs/guides/logs/java",
          name: "Java Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/JavaView.vue"),
        },
        {
          path: "/docs/guides/logs/javascript",
          name: "Javascript Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/JavascriptView.vue"),
        },
        {
          path: "/docs/guides/logs/nodejs",
          name: "NodeJS Logs Initial Setup",
          component: () => import("@/views/Docs/Topics/Guides/Logs/NodeJS.vue"),
        },
        {
          path: "/docs/guides/logs/php",
          name: "PHP Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/PhpView.vue"),
        },
        {
          path: "/docs/guides/logs/python",
          name: "Python Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/PythonView.vue"),
        },
        {
          path: "/docs/guides/logs/ruby",
          name: "Ruby Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/RubyView.vue"),
        },
        {
          path: "/docs/guides/logs/rust",
          name: "Rust Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/RustView.vue"),
        },
        {
          path: "/docs/guides/logs/swift",
          name: "Swift Logs Initial Setup",
          component: () =>
            import("@/views/Docs/Topics/Guides/Logs/SwiftView.vue"),
        },
      ],
    },
    {
      path: "/docs/guides/application_walkthrough",
      name: "Application Walkthrough",
      component: () => import("@/views/Docs/Topics/Guides/AppWalkthrough.vue"),
    },
    {
      path: "/docs/guides/logs_walkthrough",
      name: "Logs Walkthrough",
      component: () =>
        import(
          "@/views/Docs/Topics/Guides/LogsWalkthrough/LogsWalkthrough.vue"
        ),
    },
    {
      path: "/docs/guides/collector_setup",
      name: "Collector Setup",
      component: () => import("@/views/Docs/Topics/Guides/CollectorSetup.vue"),
    },
    {
      path: "/docs/application",
      name: "Application View",
      redirect: "/docs/application/administration",
    },
    {
      path: "/docs/application/overview",
      name: "Overview",
      component: () =>
        import("@/views/Docs/Topics/Application/OverviewView.vue"),
    },
    {
      path: "/docs/application/administration",
      name: "Administration Guide",
      component: () =>
        import("@/views/Docs/Topics/Application/AdministrationView.vue"),
    },
    {
      path: "/docs/application/alerting",
      name: "Alerting Docs",
      component: () =>
        import("@/views/Docs/Topics/Application/AlertingDocs.vue"),
    },
    {
      path: "/docs/application/data_table",
      name: "Data Table Docs",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/DataTableDocs/DataTableDocs.vue"
        ),
    },
    {
      path: "/docs/application/ingest_keys",
      name: "Ingest Keys Docs",
      component: () =>
        import("@/views/Docs/Topics/Application/IngestKeysDocs.vue"),
    },
    {
      path: "/docs/application/user_access",
      name: "User Access Docs",
      component: () =>
        import("@/views/Docs/Topics/Application/UserAccessDocs.vue"),
    },
    {
      path: "/docs/application/insights_view/performance",
      name: "Performance",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/InsightsView/PerformanceChart.vue"
        ),
    },
    {
      path: "/docs/application/insights_view/long_duration",
      name: "Long Duration",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/InsightsView/LongDurationTable.vue"
        ),
    },
    {
      path: "/docs/application/insights_view/long_queries",
      name: "Long Queries",
      component: () =>
        import("@/views/Docs/Topics/Application/InsightsView/LongQueries.vue"),
    },
    {
      path: "/docs/application/insights_view/high_query_count",
      name: "Highest Query Count",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/InsightsView/HighestQueryCount.vue"
        ),
    },
    {
      path: "/docs/application/insights_view/errors",
      name: "Errors",
      component: () =>
        import("@/views/Docs/Topics/Application/InsightsView/ErrorsTable.vue"),
    },
    {
      path: "/docs/application/insights_view/outliers",
      name: "Outliers",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/InsightsView/OutliersTable.vue"
        ),
    },
    {
      path: "/docs/application/insights_view/latency",
      name: "Latency",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/InsightsView/LatencyHistogram.vue"
        ),
    },
    {
      path: "/docs/application/traces_view/filtering_time_selector",
      name: "Traces Filtering/Time Selector Guide",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/TracesView/Filtering_TimeSelection.vue"
        ),
    },
    {
      path: "/docs/application/traces_view/traces_list",
      name: "Traces List Guide",
      component: () =>
        import("@/views/Docs/Topics/Application/TracesView/TracesListDocs.vue"),
    },
    {
      path: "/docs/application/traces_view/traces_data_explorer",
      name: "Traces Data Explorer Guide",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/TracesView/TracesDataExplorerDocs.vue"
        ),
    },
    {
      path: "/docs/application/logs_view/filtering_time_selector",
      name: "Logs Filtering/Time Selector Guide",
      component: () =>
        import(
          "@/views/Docs/Topics/Application/LogsView/FilteringTimeSelection.vue"
        ),
    },
    {
      path: "/docs/application/logs_view/logs_walkthrough",
      name: "Logs Walkthrough",
      component: () =>
        import(
          "@/views/Docs/Topics/Guides/LogsWalkthrough/LogsWalkthrough.vue"
        ),
    },
    {
      path: "/docs/application/usage_view",
      name: "Usage View",
      component: RouterView,
      children: [
        {
          path: "/docs/application/usage_view/usage_alerting",
          name: "Usage Alerting",
          component: () =>
            import(
              "@/views/Docs/Topics/Application/UsageView/UsageAlerting.vue"
            ),
        },
      ],
    },
    {
      path: "/docs/application/notifications",
      name: "Notifications View",
      component: RouterView,
      children: [
        {
          path: "/docs/application/notifications/email",
          name: "Email Notifications",
          component: () =>
            import(
              "@/views/Docs/Topics/Application/Notifications/EmailDocs.vue"
            ),
        },
        {
          path: "/docs/application/notifications/webhook",
          name: "Webhook Notifications",
          component: () =>
            import(
              "@/views/Docs/Topics/Application/Notifications/WebhookDocs.vue"
            ),
        },
      ],
    },
    {
      path: "/docs/troubleshooting",
      name: "TelemetryHub Troubleshooting",
      component: () =>
        import("@/views/Docs/Topics/Troubleshooting/TroubleshootingView.vue"),
    },
    {
      path: "/docs/changelog",
      name: "TelemetryHub Changelog",
      component: () => import("@/views/Docs/Topics/ChangelogView.vue"),
    },
    // Redirect Routes
    {
      path: "/docs/application/traces_view/insights",
      name: "Insights Errors",
      redirect: "/docs/application/insights_view/errors",
    },
  ],
};

export const routes = [docsRoutes];
export default docsRoutes;
